import { FieldTitle, useGetIdentity, useRecordContext, useTranslate } from "ra-core";
import { useWatch, useFormContext } from "react-hook-form";
import { FormField, FormLabel } from "@/components/admin/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { Sale } from "../types";
import {
  getUserRole,
  USER_ROLE_CHOICES,
  userRoleToFlags,
  type UserRole,
} from "./userRoles";

export const UserRoleSelect = () => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const { setValue } = useFormContext();
  const administrator = useWatch({ name: "administrator" });
  const manager = useWatch({ name: "manager" });
  const role = getUserRole({
    administrator: !!administrator,
    manager: !!manager,
  });
  const readOnly = record?.id === identity?.id;

  const handleRoleChange = (nextRole: UserRole) => {
    const flags = userRoleToFlags(nextRole);
    setValue("administrator", flags.administrator, { shouldDirty: true });
    setValue("manager", flags.manager, { shouldDirty: true });
  };

  return (
    <FormField id="user-role" name="role" className="w-full">
      <FormLabel>
        <FieldTitle
          label="resources.sales.fields.role"
          source="role"
          resource="sales"
        />
      </FormLabel>
      <Select
        value={role}
        onValueChange={(value) => handleRoleChange(value as UserRole)}
        disabled={readOnly}
      >
        <SelectTrigger className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {USER_ROLE_CHOICES.map((choice) => (
            <SelectItem key={choice.id} value={choice.id}>
              {translate(choice.name, {
                _: choice.id === "admin"
                  ? "Administrator"
                  : choice.id === "manager"
                    ? "Manager"
                    : "User",
              })}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FormField>
  );
};
